export default __webpack_public_path__ + "static/media/Encoders.8f6bb993.jpg";